<mat-tab-group [(selectedIndex)]="selectedTabIndex">
  <mat-tab label="Windows agent">
  <update-windows-client></update-windows-client>

  </mat-tab>
  <mat-tab label="Android app">
    <update-android-client></update-android-client>
  </mat-tab>
</mat-tab-group>
